import React from 'react'
import NumberCell from '../NumberCell'

class TreadleNumbersRow extends React.Component {

    createNumberDisplayCell(treadleDisplayNumber) {
        let keyValue = 'cell' + treadleDisplayNumber
        let numberDisplayCell = 
        <NumberCell key={keyValue} cellData = { treadleDisplayNumber } />
        return numberDisplayCell
    }

    createTreadleNumberDisplayCells() {
        let cellsArray = []
        for (let c=0; c < this.props.cellsCount; c++) {
            cellsArray.push(this.createNumberDisplayCell(c+1))
        }
        // empty cell at end to go underneath the shaft display number labels as the bottom left corner of the grid
        cellsArray.push(this.createNumberDisplayCell(''))
        return cellsArray
    }

    render() {

        return (
            <div className='reducer-tieup-row'>
                { this.createTreadleNumberDisplayCells() }
            </div>
        )
    }

}

export default TreadleNumbersRow


// WEBPACK FOOTER //
// ./src/scenes/reducer/components/TreadleNumbersRow/index.js